import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-091897b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  role: "row",
  class: "top-row"
}
const _hoisted_2 = { colspan: "100%" }
const _hoisted_3 = { width: "100%" }
const _hoisted_4 = {
  key: 0,
  class: "vehicle-checkbox"
}
const _hoisted_5 = {
  class: "dashboard__table-th text-left",
  "aria-sort": "none"
}
const _hoisted_6 = { class: "dashboard__table-title top-row-cell padding-25" }
const _hoisted_7 = {
  key: 1,
  class: "dashboard__table-th dashboard__table-sorting text-left"
}
const _hoisted_8 = { class: "dashboard__table-th dashboard__table-sorting text-left" }
const _hoisted_9 = { class: "dashboard__table-title top-row-cell" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "dashboard__table-th dashboard__table-sorting text-left" }, null, -1))
const _hoisted_11 = { class: "dashboard__table-th dashboard__table-sorting text-left" }
const _hoisted_12 = {
  class: "dashboard__table-th",
  "aria-sort": "none"
}
const _hoisted_13 = { class: "dashboard__table-title top-row-cell" }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { colspan: "100%" }
const _hoisted_16 = { class: "spinner" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UploadCmrPopup = _resolveComponent("UploadCmrPopup")!
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_order_vehicle_item = _resolveComponent("order-vehicle-item")!
  const _component_p_spinner = _resolveComponent("p-spinner")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.showPopup)
      ? (_openBlock(), _createBlock(_component_UploadCmrPopup, {
          key: 0,
          onClose: _ctx.closePopup
        }, null, 8, ["onClose"]))
      : _createCommentVNode("", true),
    _createElementVNode("tr", _hoisted_1, [
      _createElementVNode("td", _hoisted_2, [
        _createElementVNode("table", _hoisted_3, [
          _createElementVNode("tr", null, [
            (['3', '4', '5'].includes(_ctx.orderStatus ?? ''))
              ? (_openBlock(), _createElementBlock("th", _hoisted_4))
              : _createCommentVNode("", true),
            _createElementVNode("th", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_i18n_t, { keypath: "cart.status" })
              ])
            ]),
            (['2', '3', '4', '5', '6'].includes(_ctx.orderStatus ?? ''))
              ? (_openBlock(), _createElementBlock("th", _hoisted_7))
              : _createCommentVNode("", true),
            _createElementVNode("th", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_i18n_t, { keypath: "cart.cars" })
              ])
            ]),
            _hoisted_10,
            _createElementVNode("th", _hoisted_11, [
              _createElementVNode("div", {
                class: "dashboard__table-title top-row-cell",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changeAmountSortOrder && _ctx.changeAmountSortOrder(...args)))
              }, [
                _createVNode(_component_i18n_t, { keypath: "cart.orderAmount" })
              ])
            ]),
            _createElementVNode("th", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_i18n_t, { keypath: "myOrders.actions" })
              ])
            ])
          ]),
          (_ctx.orderVehicles.length > 0)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.orderVehicles, (vehicle) => {
                return (_openBlock(), _createBlock(_component_order_vehicle_item, {
                  key: vehicle.id,
                  order: _ctx.order,
                  orderVehicle: vehicle,
                  orderStatus: _ctx.orderStatus,
                  payments: _ctx.payments,
                  sortOrder: _ctx.sortOrder,
                  _selectedCars: _ctx.selectedCars,
                  "onUpdate:_selectedCars": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedCars) = $event)),
                  _isPaymentsTransactionsPopup: _ctx.isPaymentsTransactionsPopup,
                  "onUpdate:_isPaymentsTransactionsPopup": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isPaymentsTransactionsPopup) = $event)),
                  _orderPaymentDto: _ctx.orderPaymentDto,
                  "onUpdate:_orderPaymentDto": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.orderPaymentDto) = $event)),
                  _orderId: _ctx.orderId,
                  "onUpdate:_orderId": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.orderId) = $event)),
                  fetchOrders: _ctx.fetchOrders
                }, null, 8, ["order", "orderVehicle", "orderStatus", "payments", "sortOrder", "_selectedCars", "_isPaymentsTransactionsPopup", "_orderPaymentDto", "_orderId", "fetchOrders"]))
              }), 128))
            : (_openBlock(), _createElementBlock("tr", _hoisted_14, [
                _createElementVNode("td", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_p_spinner, {
                      strokeWidth: "8",
                      animationDuration: ".8s"
                    })
                  ])
                ])
              ]))
        ])
      ])
    ])
  ], 64))
}